import { useEffect, useState } from "react";
import { CalendarHeart, Sparkles, Clock } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";
import { OPENING_DATE, isPreOpening } from "../../lib/openingDate";

function pieces(diff) {
  const sec = Math.max(0, Math.floor(diff / 1000));
  return {
    d: Math.floor(sec / 86400),
    h: Math.floor((sec % 86400) / 3600),
    m: Math.floor((sec % 3600) / 60),
    s: sec % 60,
  };
}

export default function EmBreve() {
  const { t } = useT();
  const [left, setLeft] = useState(pieces(OPENING_DATE - new Date()));

  useEffect(() => {
    if (!isPreOpening()) return;
    const id = setInterval(() => setLeft(pieces(OPENING_DATE - new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  if (!isPreOpening()) return null;

  const cells = [
    { n: left.d, l: t.embreve.days },
    { n: left.h, l: t.embreve.hours },
    { n: left.m, l: t.embreve.minutes },
    { n: left.s, l: t.embreve.seconds },
  ];

  return (
    <section className="py-20 md:py-28 bg-noite text-[#faf6ee] relative overflow-hidden" data-testid="embreve-section">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-[#e3b25b]/8 blur-3xl pointer-events-none" />
      <div className="absolute inset-0 opacity-30 pointer-events-none"
           style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(227,178,91,0.25) 1px, transparent 1px)", backgroundSize: "30px 30px" }} />

      <div className="max-w-5xl mx-auto px-6 relative text-center">
        <div className="reveal inline-flex items-center gap-2 border border-[#e3b25b]/40 text-[#e3b25b] px-5 py-2 rounded-full text-[11px] font-semibold tracking-[0.22em] uppercase">
          <Sparkles size={12} /> {t.embreve.badge}
        </div>

        <h2 className="reveal font-display text-5xl sm:text-6xl md:text-7xl mt-8 leading-[1.05]">
          {t.embreve.title1}
          <br />
          <em className="text-[#e3b25b]">{t.embreve.title2}</em>
        </h2>

        <p className="reveal mt-6 text-lg text-[#faf6ee]/80 max-w-2xl mx-auto leading-relaxed">
          {t.embreve.subtitle}
        </p>

        <div className="reveal grid grid-cols-4 gap-2 sm:gap-4 mt-12 max-w-3xl mx-auto">
          {cells.map((c) => (
            <div
              key={c.l}
              className="bg-[#1a2c5c]/55 ring-1 ring-white/10 rounded-2xl py-5 sm:py-7 px-2"
              data-testid={`countdown-${c.l.toLowerCase()}`}
            >
              <p className="font-display text-3xl sm:text-5xl md:text-6xl text-gold-metal font-medium leading-none tabular-nums">
                {String(c.n).padStart(2, "0")}
              </p>
              <p className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#faf6ee]/65 mt-3">{c.l}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-10 inline-flex items-center gap-2 text-sm text-[#faf6ee]/75 bg-[#1a2c5c]/40 backdrop-blur px-5 py-2.5 rounded-full ring-1 ring-white/10">
          <Clock size={14} className="text-[#e3b25b]" /> {t.embreve.hint}
        </div>

        <div className="reveal mt-10 flex flex-wrap gap-4 justify-center">
          <a href="#reserva" className="btn-primario" data-testid="embreve-cta">
            <CalendarHeart size={14} /> {t.embreve.cta}
          </a>
        </div>
      </div>
    </section>
  );
}
